module.exports = {
  docsMap: {
    "University Acceptance Letter": "University Acceptance Letter",
    "Student registration contract": "Student registration contract",
    "Payslip month 1": "1st month payslip",
    "Payslip month 2": "2nd month payslip",
    "Payslip month 3": "3rd month payslip",
    "Payslip Month 1": "1st month payslip",
    "Payslip Month 2": "2nd month payslip",
    "Payslip Month 3": "3rd month payslip",
    "Social Security Contribution Report": "Deduction certificate",
    "Employment contract": "Employment contract",
    "Annual payment certificate": "Annual payment certificate",
    "Deduction certificate": "Deduction certificate",
    "Working life certificate": "Working life certificate",
    "Last annual Tax Report (Model 100)": "Last annual Tax Report (Model 100)",
    "Last Fractionated Tax Report (Model 130)":
      "Last Fractionated Tax Report (Model 130)",
    "Last quarterly VAT tax (Form 303)": "Last quarterly VAT tax (Form 303)",
    "Comprehensive certificate of benefits":
      "Comprehensive certificate of benefits",
    "Last revalorization letter": "Last revalorization letter",
    "Last year's Corporate Tax Return": "Last year's Corporate Tax Return",
    "Last year's Corporate balance sheet":
      "Last year's Corporate balance sheet",
  },
  forensic_docs_map: {
    student: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [
        "University Acceptance Letter",
        "Student registration contract",
      ],
      income_taxes: [],
    },
    employed: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: ["Employment contract", "Working life certificate"],
      income_taxes: [
        // "Payslip",
        "Payslip month 1",
        "Payslip month 2",
        "Payslip month 3",
        "Deduction certificate",
        "Last annual Tax Report (Model 100)",
      ],
    },
    domestic_worker: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: ["Employment contract", "Working life certificate"],
      income_taxes: [
        "Annual payment certificate",
        "Deduction certificate",
        "Last annual Tax Report (Model 100)",
      ],
    },
    freelancer: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [
        // "Employment contract",
        "Working life certificate",
      ],
      income_taxes: [
        "Last annual Tax Report (Model 100)",
        "Last Fractionated Tax Report (Model 130)",
        "Deduction certificate",
        "Last quarterly VAT tax (Form 303)",
      ],
    },
    retired: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [],
      income_taxes: [
        "Comprehensive certificate of benefits",
        "Last revalorization letter",
      ],
    },
    unemployed: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: ["Working life certificate"],
      income_taxes: [
        "Comprehensive certificate of benefits",
        "Last annual Tax Report (Model 100)",
      ],
    },
    ownACompany: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [
        "Working life certificate",
        "Company Incorporation Documents",
      ],
      income_taxes: [
        "Last annual Tax Report (Model 100)",
        "Last Fractionated Tax Report (Model 130)",
        "Deduction certificate",
        "Last year's Corporate Tax Return",
        "Last year's Corporate balance sheet",
        "Last year's Corporate P&L",
      ],
    },
    public_servant: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [
        "Working life certificate",
        "Official Appointment Notice (Official Gazette)",
      ],
      income_taxes: [
        "Last annual Tax Report (Model 100)",
        // "Payslip",
        "Payslip month 1",
        "Payslip month 2",
        "Payslip month 3",
        "Deduction certificate",
      ],
    },
    company: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: ["Company Incorporation Documents"],
      income_taxes: [
        "Last year's Corporate Tax Return",
        "Last quarterly VAT tax (Form 303) Q1",
        "Last quarterly VAT tax (Form 303) Q2",
        "Last quarterly VAT tax (Form 303) Q3",
        "Last quarterly VAT tax (Form 303) Q4",
      ],
    },
  },
  dea_missing_docs: {
    student: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [],
      income_taxes: [],
    },
    employed: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: ["Employment contract", "Working life certificate"],
      income_taxes: [
        // "Payslip",
        "Payslip month 1",
        "Payslip month 2",
        "Payslip month 3",
      ],
    },
    // domestic_worker: {
    //   identification: [
    //     "passport",
    //     "national_identity_card_front",
    //     "national_identity_card_back",
    //     "residence_permit_front",
    //     "residence_permit_back",
    //   ],
    //   employment_status: ["Employment contract", "Working life certificate"],
    //   income_taxes: ["Annual payment certificate"],
    // },
    freelancer: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: ["Working life certificate"],
      income_taxes: [
        "Last annual Tax Report (Model 100)",
        "Last quarterly VAT tax (Form 303)",
      ],
    },
    retired: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [],
      income_taxes: [
        "Comprehensive certificate of benefits",
        "Last revalorization letter",
      ],
    },
    unemployed: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [],
      income_taxes: [],
    },
    ownACompany: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [
        "Working life certificate",
        "Company Incorporation Documents",
      ],
      income_taxes: [
        "Last annual Tax Report (Model 100)",
        "Last year's Corporate Tax Return",
      ],
    },
    public_servant: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: [
        "Working life certificate",
        "Official Appointment Notice (Official Gazette)",
      ],
      income_taxes: [
        // "Payslip",
        "Payslip month 1",
        "Payslip month 2",
        "Payslip month 3",
      ],
    },
    company: {
      identification: [
        "passport",
        "national_identity_card_front",
        "national_identity_card_back",
        "residence_permit_front",
        "residence_permit_back",
      ],
      employment_status: ["Company Incorporation Documents"],
      income_taxes: [
        "Last year's Corporate Tax Return",
        "Last quarterly VAT tax (Form 303) Q1",
        "Last quarterly VAT tax (Form 303) Q2",
        "Last quarterly VAT tax (Form 303) Q3",
        "Last quarterly VAT tax (Form 303) Q4",
      ],
    },
  },
};
